/**
 * Global tracking utilities
 * 
 * Provides a way to call tracking functions from outside the React component tree.
 * Used to ensure SESSION_END is fired and flushed before logout.
 */

// Global ref to the trackSessionEnd function set by SessionTracker
let _trackSessionEndFn = null;
let _flushTrackingFn = null;

export const setTrackSessionEndFn = (fn) => { _trackSessionEndFn = fn; };
export const setFlushTrackingFn = (fn) => { _flushTrackingFn = fn; };

/**
 * Call this before logout to:
 * 1. Fire SESSION_END with correct user context
 * 2. Flush the batch immediately so it's sent before sign out
 */
export const trackLogout = async () => {
  try {
    console.log('[trackingUtils] trackLogout called', { 
      hasTrackSessionEnd: !!_trackSessionEndFn, 
      hasFlush: !!_flushTrackingFn 
    });
    if (_trackSessionEndFn) {
      await _trackSessionEndFn('logout');
    }
    if (_flushTrackingFn) {
      await _flushTrackingFn();
    }
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.removeItem('tracking_session_id');
    }
    console.log('[trackingUtils] trackLogout completed');
  } catch (e) {
    console.warn('[trackingUtils] Failed to track logout:', e);
  }
};
